<button class="btn btn-sm"
  [ngClass]="props.btnClass"
  [type]="props.type"
  (click)="onClick()">
  <i *ngIf="props.iconClass"
    class="me-2"
    [ngClass]="props.iconClass"></i>{{ props.label }}
</button>